import React from 'react';
import { useRouter } from 'next/router';
import ActionSheet from 'components/Common/ActionSheet';
import MuiButton from 'components/Common/MuiButton';
import i18n from 'locales/fa.json';
import { StyledDiv } from 'theme/commonStyled';
import Icon from 'components/Common/Icon';
import { PackagesRoute } from 'routes/wallet.routes';
import useProfileStore from 'store/profile';

const PermissionActionSheet: React.FC = () => {
  const router = useRouter();
  const setPermissionAction = useProfileStore(
    (state) => state.setPermissionAction,
  );
  return (
    <ActionSheet
      footer={false}
      open
      onDismiss={(): void => {
        setPermissionAction(false);
      }}
    >
      <StyledDiv textAlign="center">
        <Icon name="warning" fontSize={21} color="sun80" />
        <StyledDiv my={4} fontSize={4} color="ash100" fontWeight="600">
          {i18n.global.messages.paymentPopupMessage1}
        </StyledDiv>
        <StyledDiv
          fontSize={4}
          px={8}
          textAlign="center"
          color="ash90"
          fontWeight="400"
          lineHeight="2"
        >
          {i18n.global.messages.paymentPopupMessage2}
        </StyledDiv>
        <StyledDiv isCenter mt={10} gap={10}>
          <MuiButton
            variant="white"
            flex={1}
            onClick={(): void => setPermissionAction(false)}
          >
            {i18n.addToHomeScreen.buttonText}
          </MuiButton>
          <MuiButton
            flex={1}
            type="submit"
            onClick={(): void => {
              setPermissionAction(false);
              router.push(PackagesRoute());
            }}
          >
            {i18n.wallet.basket.buyPackage}
          </MuiButton>
        </StyledDiv>
      </StyledDiv>
    </ActionSheet>
  );
};

export default PermissionActionSheet;
